// extracted by mini-css-extract-plugin
export default {"root":"FullPageLoader_root__zE17p","active":"FullPageLoader_active__Ra9vX"};